import "./ExcelNoticeCards.css";

export default function ExcelWarningsCard({ warnings = [] }) {
  if (!warnings.length) return null;

  return (
    <section className="excel-notice-card excel-notice-card--warning">
      <h3>Waarschuwingen</h3>
      <p>
        Waarschuwingen blokkeren de import niet, maar moeten nagekeken worden.
      </p>

      <div className="excel-notice-card__list">
        {warnings.map((warning, index) => (
          <div key={index} className="excel-notice-card__item">
            <strong>{warning.type || "Waarschuwing"}</strong>
            <span>{warning.message || JSON.stringify(warning)}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
